"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const useNavigation_1 = require("src/hooks/useNavigation");
const layouts_1 = require("../shared/layouts");
const Subscription = () => {
    // TODO handle other process params
    const { teamId } = (0, react_router_1.useParams)();
    const { navigate } = (0, useNavigation_1.useNavigation)();
    React.useEffect(() => {
        // @ts-ignore
        if (window?.webkit?.messageHandlers?.webCheckoutObserver) {
            // @ts-ignore
            window.webkit.messageHandlers.webCheckoutObserver.postMessage({
                event: 'flowFinished',
            });
            return;
        }
        navigate.v1TeamPlanManage(teamId);
    }, []);
    return (React.createElement(layouts_1.BasicWrapper, null,
        React.createElement("div", { className: "sui-text-center loading-page-content sui-my-4" },
            React.createElement(teamsnap_ui_1.Loader, { type: "pulse", size: { height: 16, width: 16 } }))));
};
exports.default = Subscription;
